import BaseList from './BaseList';
import StageData from './StageData';
import type { StageListItem } from './StageData';

/**
 * Lists of stages. 
 */
class StageList extends BaseList<StageData> {
   
    // Key field
    keyField = 'id';
        
    /**
     * Build from list items from rest response.
     */
    static fromListItems(listItems: StageListItem[]): StageList {
        const dataItems: StageData[] = [];
        
        listItems.forEach((item) => {
              dataItems.push(StageData.fromListItem(item));
        });
        
        return new StageList(dataItems);
    }  

}

export default StageList;
